module.exports = __webpack_public_path__ + "static/dentist-79e7afc0d86d9a96f74f90b1b4d63d95.jpg";